import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

export function MontenexResult({ invoice }) {
  const resultData = invoice.result.data;

  const { t } = useTranslation();

  const templateT = (key) => t(`Invoice.Result.Templates.Montenex.${key}`);

  return (
    <section>
      <div className="card-info block">
        <h3>{templateT('Header')}:</h3>
        <div className="block__text">
          <div className="block__inline">
            <div>{templateT('Payer')}:</div>
            <div className="card-info__method">
              {resultData.first_name} {resultData.last_name}
            </div>
          </div>
          <div className="block__inline">
            <div>{templateT('Amount')}:</div>
            <div className="card-info__method">
              {resultData.amount} {resultData.currency}
            </div>
          </div>
          <div className="block__inline">
            <div>{templateT('Number')}:</div>
            <div className="card-info__method">{resultData.invoice_name}</div>
          </div>
          <hr />
          <div className="card-info__downloadBtn">
            <p className="text--downloadInvoice ">
              <Trans i18nKey="Invoice.Result.Templates.Montenex.Text">
                Download
                <a
                  className="text--link"
                  href={resultData.invoice_url}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  invoice.pdf
                </a>{' '}
                to pay this invoice
              </Trans>
            </p>
            <a
              className="btn"
              href={resultData.invoice_url}
              target="_blank"
              rel="noreferrer noopener"
            >
              {templateT('Button')}
            </a>
            <p className="text--code">
              {templateT('Code')}: {resultData.id}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
